import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

export const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen bg-[#0B0E11] flex items-center justify-center"><div className="text-zinc-400">Loading...</div></div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
};
